__turbopack_context__.v({
  "chipRow": "stubs-module-scss-module__94ZoTa__chipRow",
  "pageRow": "stubs-module-scss-module__94ZoTa__pageRow",
  "section": "stubs-module-scss-module__94ZoTa__section",
  "spread": "stubs-module-scss-module__94ZoTa__spread",
  "stack": "stubs-module-scss-module__94ZoTa__stack",
  "stackSm": "stubs-module-scss-module__94ZoTa__stackSm",
  "stackXs": "stubs-module-scss-module__94ZoTa__stackXs",
});
